import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, InjectionToken } from '@angular/core';
import { ServerRootService } from '@se/se.ui.html5';
import { noop } from 'lodash-es';

export const ESTENSA_MODULE_AUTHENTICATION_SSO_SERVICE = new InjectionToken(
    'estensa.module.authentication.sso.service',
);

export interface IAuthenticationSSOServiceNg1 {
    initializeFromUrl(): void;
    getQueryString(): Record<string, string>;
}

export enum PairingDataType {
    WadoResponse = 1,
    ReportTemplateResponse,
    AuthenticationTicket_For_RefreshToken,
    ParameterDictionary,
}
export interface PairingData {
    dataType: PairingDataType;
    httpResponseContentType: string;
    parameterDictionary: Record<string, string>;
}

@Injectable()
export class NullAuthenticationSSOService implements IAuthenticationSSOServiceNg1 {
    initializeFromUrl = noop;
    getQueryString = () => ({});
}

@Injectable({
    providedIn: 'root',
})
export class AuthenticationSSOService implements IAuthenticationSSOServiceNg1 {
    constructor(
        @Inject(ESTENSA_MODULE_AUTHENTICATION_SSO_SERVICE)
        private authenticationSSOService: IAuthenticationSSOServiceNg1,
        private http: HttpClient,
        private serverRoot: ServerRootService,
    ) {}

    initializeFromUrl() {
        this.authenticationSSOService.initializeFromUrl();
    }

    getQueryString() {
        return this.authenticationSSOService.getQueryString();
    }

    getPairingData(pairingToken: string) {
        return this.http.post<PairingData>(
            `${this.serverRoot.getServerRoot()}/Authentication/GetPairingData`,
            { pairingToken },
            this.serverRoot.buildOptions(),
        );
    }
}
